module.exports = __webpack_public_path__ + "assets/img/apple-touch-icon.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/apple-touch-icon.png
// module id = 1918
// module chunks = 0